UC.components.AvailabilityTimeRange = Backbone.Model.extend({});
